module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "brand-logo",
    class: {
      'brand-logo--light': _vm.light,
      'brand-logo--large': _vm.large,
    }
  }, [_vm._v("LEAGUEPOINTS"), _c('span', [_vm._v(".")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7740ba23","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BrandLogo.vue
// module id = 407
// module chunks = 1